var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZapierGray2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13024",
    "data-name": "Group 13024",
    transform: "translate(-80 -177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Zapier"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2503",
    "data-name": "Rectangle 2503",
    width: 40,
    height: 40,
    rx: 4,
    transform: "translate(80 177)",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Zapier_logo",
    d: "M289.769,13.286a7.784,7.784,0,0,1-.5,2.745,7.794,7.794,0,0,1-2.745.5h-.011a7.787,7.787,0,0,1-2.746-.5,7.776,7.776,0,0,1-.5-2.745v-.012a7.784,7.784,0,0,1,.5-2.745,7.769,7.769,0,0,1,2.746-.5h.011a7.756,7.756,0,0,1,2.745.5,7.77,7.77,0,0,1,.5,2.745v.012h0Zm9.569-2.173H291.75l5.365-5.365a13.053,13.053,0,0,0-3.064-3.064l-5.366,5.365V.461A13.062,13.062,0,0,0,286.525.28h-.014a13.021,13.021,0,0,0-2.16.181V8.049l-5.367-5.366a12.982,12.982,0,0,0-1.658,1.4l0,0a13.081,13.081,0,0,0-1.4,1.658l5.367,5.365H273.7s-.181,1.426-.181,2.163v.009a13.006,13.006,0,0,0,.181,2.162h7.59l-5.368,5.365a13.091,13.091,0,0,0,3.065,3.064l5.366-5.365V26.1a13.12,13.12,0,0,0,2.157.181h.018a13.117,13.117,0,0,0,2.157-.181V18.511l5.367,5.366a13.1,13.1,0,0,0,1.66-1.4h0a13.128,13.128,0,0,0,1.4-1.66l-5.365-5.367h7.59a13.051,13.051,0,0,0,.18-2.158v-.019a13.067,13.067,0,0,0-.18-2.157h0Z",
    transform: "translate(-186.518 183.72)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapierGray2);
export default __webpack_public_path__ + "static/media/Zapier-gray (2).1f078c2423430fc95bf4003fbc1a00db.svg";
export { ForwardRef as ReactComponent };